import { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Control, Typography } from '@modulor/react';
import Modal from '../Modal/Modal';
import { Local } from '../Local/Local';
import { ModulorButtonWithAnalytics } from '../Modulor/Button';
import { isRecentGamesMigrationModalOpenedSelector } from '../../redux/reducers/ui/modals';
import { useMigrationModalManager } from './hooks';
import { getDataTestAttributes } from '../../utils/testing-locators';
import {
  RECENT_GAMES_MIGRATION_BUTTON,
  RECENT_GAMES_MIGRATION_CHECKBOX,
  RECENT_GAMES_MIGRATION_MODAL,
} from '../../constants/dataTestIds';
import styles from './RecentsMigrationModal.module.css';

const RecentsMigrationModal = () => {
  const isOpen = useSelector(isRecentGamesMigrationModalOpenedSelector);

  const [isChecked, setIsChecked] = useState(false);
  const { hideModal } = useMigrationModalManager();

  const closeModal = useCallback(() => {
    hideModal(isChecked);
  }, [hideModal, isChecked]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      overlayClassName={styles.overlay}
    >
      <div
        className={styles.wrapper}
        {...getDataTestAttributes(RECENT_GAMES_MIGRATION_MODAL)}
      >
        <Typography variant="title-1-semibold" className={styles.title}>
          <Local>Updates in process</Local>
        </Typography>
        <Typography variant="body-regular" className={styles.description}>
          <Local>
            We work to make the product faster and better for you. Games on your
            recently played list may disappear due to update, but there’s
            nothing to worry.
          </Local>
        </Typography>
        <div className={styles.control}>
          <Control
            type="checkbox"
            name="show-again"
            checked={isChecked}
            onChange={setIsChecked}
            className={styles.checkbox}
            {...getDataTestAttributes(RECENT_GAMES_MIGRATION_CHECKBOX)}
          />
          <Typography
            variant="body-regular"
            className={styles.label}
            onClick={() => {
              setIsChecked((checked) => !checked);
            }}
          >
            <Local>Do not show this message again</Local>
          </Typography>
        </div>
        <ModulorButtonWithAnalytics
          onClick={closeModal}
          className={styles.button}
          {...getDataTestAttributes(RECENT_GAMES_MIGRATION_BUTTON)}
        >
          <Local>Got it!</Local>
        </ModulorButtonWithAnalytics>
      </div>
    </Modal>
  );
};

export default RecentsMigrationModal;
